
<div class="lm-border pa-3" :class="background">
    <div class="v-flex step-title ">
        <div class=" primary--text" style="padding-top: 3px;">
            <span>{{ $t('invoice.sum.title') }}</span>
            <span>
                {{ toMoney (invoice.item.amount.net) }}
            </span>
        </div>

        <inc-invoice-stamp-menu
            :data    = "invoice"
            @stamped = "onStamped"
            @mail    = "onSendStampMail"
            @reset   = "onReset"
            style="margin-bottom: 3px;"
        />
    </div>

    <!-- Invoice dates -->
    <p-inc-invoice-dates
        :data       = "invoice"
        :collective = "collective"
    />
    <!-- Invoice dates -->

    <!-- Invoice number and invoice date -->
    <v-row class="no-frame mt-2" >
        <v-col class="no-frame mr-2">
            <v-text-field
                v-model           = "invoice.invoicenumber"
                :rules            = "[requiredOnTerminationRule]"
                :label            = "$t('invoice.invoicenumber')"
                :background-color = "collective ? 'field-group-background-blue' : ''"
                autocomplete      = "off"
                autocorrect       = "off"
                autocapitalize    = "off"
                spellcheck        = "false"
            />
        </v-col>
        <v-col class="no-frame ml-2">
            <f-date-picker
                v-model           = "invoice.invoiceDate"
                label             = "invoice.invoiceDate"
                :background-color = "collective ? 'field-group-background-blue' : ''"
                :time             = "false"
            />

        </v-col>
    </v-row>

    <v-row dense class="no-frame" style="margin-bottom: 10px!important;">
        <v-col class="no-frame pr-1">
            <f-read-only-field
                :label       = "$t('invoice.cost.net')"
                :value       ="toMoney (invoice.item.calculated.net)"
                :align-right = "true"
                :collective  = "collective"
                :filled      = "!collective"
                dense
            />
        </v-col>

        <v-col class="no-frame pl-1">
            <f-read-only-field
                :key         = "refresh"
                :label       = "$t('invoice.cost.invoice')"
                :value       = "toMoney (invoice.item.calculated.correction)"
                :align-right = "true"
                :collective  = "collective"
                :filled      = "!collective"
                dense
            />
        </v-col>
    </v-row>
</div>
